import { productsKeyConstants } from '../../config';
import {
  rfPainRelief,
  rfZenFactor,
  rfZFactor,
  rfGoFactor,
  rfThinkFactor,
} from '../../src/images';

export const BEACON_TOKEN_KEY = 'beaconToken';

export const initialPriceProducts = [
  productsKeyConstants.RF_QUICKSTART,
  productsKeyConstants.RF_60CT_SINGLE,
  productsKeyConstants.RF_SLEEP,
  productsKeyConstants.RF_RELIEF_FACTOR_60_CT_SINGLE,
  productsKeyConstants.RF_GO_FACTOR_SINGLE,
  productsKeyConstants.RF_ZEN_FACTOR_SINGLE,
  productsKeyConstants.RF_Z_FACTOR_SINGLE,
];

export const HeadTitleContent = {
  relieffactor: {
    path: '/',
    title: 'Relief Factor Co.: Celebrating 10 Years of 100% Drug-Free Wellness',
    description:
      'Relief Factor is a 100% drug-free pain relief supplement made from a unique combination of botanical ingredients and fish oil. Get relief today!',
  },
  support: {
    path: '/support',
    title: 'Customer Support | Relief Factor',
    description:
      'Have questions or concerns? Reach out to our talented support team today!',
  },
  login: { path: '/login', title: 'Login', description: 'Customer Login' },
  quickstart: {
    path: '/products/relief-factor',
    title: 'Anti-Inflammatory Pain Relief QuickStart | Relief Factor',
    description:
      'Relief Factor QuickStart is a convenient 3-week trial, including 49 packets and a 91-page anti-inflammatory diet guide. Get relief today!',
  },
  freegift: {
    path: '/freegift',
    title: 'Free Gift',
    description: 'Free gift',
  },
  calm: {
    path: '/products/zen-factor',
    title:
      'Zen Factor: All-Natural Stress Relieving Supplement | Relief Factor',
    description:
      'Zen Factor helps your body effectively deal with stress with a powerful blend of herbal extracts. Order now for free shipping and handling!',
  },
  energy: {
    path: '/products/go-factor',
    title: 'Go Factor: All-Natural Energy Boosting Supplement | Relief Factor',
    description:
      'Go Factor helps you keep going, and helps your body make nutrients readily available when you need it. Order now for free shipping & handling!',
  },
  sleep: {
    path: '/products/z-factor',
    title: 'Z Factor: All-Natural Sleep Aid Supplement | Relief Factor',
    description:
      'Z Factor, a 100% drug-free, non-addictive sleep supplement that leaves you feeling rested and restored. Order now for free shipping & handling!',
  },
  antioxidants: {
    path: '/products/antioxidants',
    title:
      'Antioxidants with Vitamin C and Bioflavinoids: All-Natural Health Support | Relief Factor Co.',
    description:
      'Antioxidants with Vitamin C and Bioflavonoids is a reliable, convenient way to protect your cells from everyday stress, support healthy aging, and boost your immune response.',
  },
  thinkfactor: {
    path: 'think-factor',
    title: 'Think Factor: All-Natural Cognition Health | Relief Factor Co.',
    description:
      'Think Factor helps power your creativity, focus, and daily performance. If you’re feeling mentally foggy or aren’t recalling things as quickly as you used to, Think Factor could be just what you need to reclaim your cognitive edge.',
  },
  fullspectrume: {
    path: '/products/full-spectrum-e',
    title: 'Full Spectrum E | Relief Factor Co.',
    description:
      'Vitamin E is a strong antioxidant that helps keep your heart healthy, protects cell membranes, and is important for DNA and protein processes, energy production, and hormone balance.',
  },
  immunefactor: {
    path: '/products/immune-factors',
    title: 'Immune Factors: All-Natural Immune Defense | Relief Factor Co.',
    description:
      'Immune Factors is a potent blend of standardized, research-backed extracts— including Echinacea, Andrographis, Berberine, and Astragalus— it’s crafted for individuals seeking a robust immune response year-round.',
  },
  nac: {
    path: '/products/nac',
    title: 'NAC (N-Acetyl L-Cysteine) | Relief Factor Co.',
    description:
      'N-Acetyl Cysteine (NAC) is a powerful antioxidant amino acid that combats free radicals. By replenishing glutathione, a key antioxidant in the body, NAC supports liver health and overall well-being.',
  },
  berberine: {
    path: '/products/berberine',
    title: 'Berberine: All-Natural Health Support | Relief Factor Co.',
    description:
      'Berberine has been traditionally celebrated for helping support healthy blood sugar levels, promoting metabolism, and aiding overall well-being. Our formula starts with a potent extract to deliver consistent quality you can trust.',
  },
  vitaminbcomplex: {
    path: '/products/vitamin-b-complex',
    title: 'Vitamin B Complex: All-Natural Energy | Relief Factor Co.',
    description:
      'Vitamin B Complex is here to help you power through each day—naturally. Discover how our high-potency formula supports better energy levels, stress management, and overall well-being.',
  },
  redyeastrice: {
    path: '/products/red-yeast-rice',
    title: 'Red Yeast Rice with CoQ10 | Relief Factor Co.',
    description:
      'Red Yeast Rice with CoQ10, time-tested way to help maintain healthy cholesterol levels and support your overall cardiovascular wellness. It delivers potent targeted nutrients—without breaking your budget. Help your body achieve healthy cholesterol levels within the normal range.',
  },
  vesselprotection: {
    path: '/products/vessel-protection',
    title: 'Vessel Protection: All-Natural Heart Health | Relief Factor Co.',
    description:
      'Vessel Protection helps you maintain a healthy heart, energy levels, and overall wellness. It is an advanced, bioactive B-vitamin supplement designed to give your cardiovascular system the targeted support it needs, while boosting your daily vitality.',
  },
  vitamindk: {
    path: '/products/vitamin-d-k',
    title: 'Vitamin D3 and K-2 | Relief Factor Co.',
    description:
      'Studies show that combining vitamins D3 and K2, both essential for calcium utilization, may offer greater benefits when taken together. Our Vitamin D3 and K2 capsules provide these nutrients in a highly absorbable form.',
  },
  faq: {
    path: '/faq',
    title: 'Frequently Asked Questions | Relief Factor',
    description:
      "Visit Relief Factor's FAQ to answer common questions about our ingredients, shipping and handling, memberships and more.",
  },
  ordersuccess: {
    path: '/ordersuccess',
    title: 'Order Success',
    description: 'Order success',
  },
  createpassword: {
    path: '/createpassword',
    title: 'Create New Password',
    description: 'Create New password',
  },
  checkout: {
    path: '/checkout',
    title: 'Checkout',
    description: 'Shopping Cart',
  },
  paymentexpired: {
    path: '/paymentexpired',
    title: 'Payment',
    description: 'Payment expired',
  },
  ingredients: {
    path: '/ingredients',
    title: 'Relief Factor Ingredients Omega-3, Curcumin, Resveratrol, Icariin',
    description:
      'Relief Factor Ingredients Omega-3, Curcumin, Resveratrol, Icariin',
  },
  turmeric: {
    path: '/turmeric',
    title: 'Ingredients - Turmeric',
    description: 'Ingredients - Turmeric',
  },
  research: {
    path: '/the-science-research',
    title:
      'The ingredients are scientifically proven to fight against inflammation',
    description:
      'The ingredients are scientifically proven to fight against inflammation',
  },

  rescheduleorder: {
    path: '/reschedule-order',
    title: 'How To Reschedule Your Shipment in the Customer Portal',
    description: 'Reschedule Order',
  },
  enablecookies: {
    path: '/enable-cookies',
    title: 'Enable Cookies',
    description: 'Enable Cookies',
  },
  somethingwentwrong: {
    path: '/something-went-wrong',
    title: 'Something Went Wrong',
    description: 'Something went wrong.',
  },
  forgotpassword: {
    path: '/forgotPassword',
    title: 'Forgot Password',
    description: 'Forgot User Password',
  },
  returnsPolicy: {
    path: '/policies/returns',
    title: 'Returns Policy',
    description:
      'We always hope you are happy with your Relief Factor purchase. If you ever need to return an order, we make it easy by following this simple return policy.',
  },
  privacyPolicy: {
    path: 'policies/privacy',
    title: 'Privacy and Customer Data Policies',
    description:
      'We take Relief Factor customer data privacy very seriously, and use the following policies to protect our customer’s privacy and data.',
  },
  shippingPolicy: {
    path: 'policies/shipping',
    title: 'Shipping Policies',
    description:
      'We follow these shipping policies to ensure prompt fulfillment and delivery of Relief Factor products to your door.',
  },
  reviews: {
    path: '/reviews',
    title: 'Relief Factor Reviews: All-Natural Anti-Inflammatory Pain Relief',
    description: `Relief Factor reviews by real customers (2023). Read reviews from 1,000's of happy customers who share their health and wellness journeys. Get relief today!`,
  },
};

export const productUpsellCarousel = [
  {
    id: 1,
    productImg: rfPainRelief,
    category: 'Pain Relief',
    productName: 'Relief Factor',
    link: '/products/relief-factor',
    gradient: '#9cd4ea87',
  },
  {
    id: 2,
    productImg: rfThinkFactor,
    category: 'Cognition Support',
    productName: 'Think Factor',
    link: '/products/think-factor',
    gradient: '#D49F345e',
  },
  {
    id: 3,
    productImg: rfZenFactor,
    category: 'Anxiety Relief',
    productName: 'Zen Factor',
    link: '/products/zen-factor',
    gradient: '#5d4d9a5e',
  },
  {
    id: 4,
    productImg: rfGoFactor,
    category: 'Energy Boost',
    productName: 'Go Factor',
    link: '/products/go-factor',
    gradient: '#50723473',
  },
  {
    id: 5,
    productImg: rfZFactor,
    category: 'Sleep Support',
    productName: 'Z Factor',
    link: '/products/z-factor',
    gradient: '#1f4e815e',
  },
];
